export const ignoreErrors = [
  'Object Not Found Matching Id',
  'The request is not allowed by the user agent or the platform in the current context',
  'wistia.com',
  'Illegal invocation',
  "Cannot read properties of undefined (reading 'sendEvents')",
];
